<div class="automation-container">
  <div class="header">
    <h4>Campagnes Automation</h4>
    <span class="badge" *ngIf="campaigns.length">{{ campaigns.length }} campagne(s)</span>
  </div>

  <div *ngIf="loading" class="loading">Chargement...</div>

  <div *ngIf="!loading && campaigns.length === 0" class="empty-state">
    <p>Aucune campagne automation.</p>
    <p class="hint">Creez un email dynamique en mode "Automation Marketing" pour commencer.</p>
  </div>

  <div class="campaigns-grid" *ngIf="!loading && campaigns.length > 0">
    <!-- Campaign List -->
    <div class="campaign-list">
      <div *ngFor="let campaign of campaigns" class="campaign-card"
        [class.selected]="selectedCampaign?.id === campaign.id" (click)="selectCampaign(campaign)">
        <div class="card-thumb-wrap" *ngIf="campaign.preview_img_url">
          <img [src]="campaign.preview_img_url" class="campaign-thumbnail" alt="apercu" />
        </div>
        <div class="card-content">
          <div class="card-header">
            <span class="campaign-name">{{ campaign.name }}</span>
            <span class="status-badge" [ngClass]="getStatusClass(campaign.status)">
              {{ campaign.status }}
            </span>
          </div>
          <div class="card-meta">
            <span *ngIf="campaign.auto_paused" class="auto-paused-tag">Auto-pause</span>
            <span class="runs-count">{{ campaign.total_runs }} mise(s) à jour</span>
            <span class="failures" *ngIf="campaign.consecutive_failures > 0">
              {{ campaign.consecutive_failures }} echec(s)
            </span>
          </div>
          <div class="card-footer">
            <span class="last-run" *ngIf="campaign.last_run_at">
              Dernière MAJ : {{ campaign.last_run_at | date:'dd/MM/yyyy HH:mm' }}
            </span>
            <span class="pending" *ngIf="campaign.pending_validations_count > 0">
              {{ campaign.pending_validations_count }} validation(s) en attente
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Campaign Detail -->
    <div class="campaign-detail" *ngIf="selectedCampaign">
      <div class="detail-header">
        <h5>{{ selectedCampaign.name }}</h5>
        <div class="actions">
          <button *ngIf="selectedCampaign.preview_img_url" class="btn btn-outline-secondary"
            (click)="openPreview(selectedCampaign)">
            Apercu
          </button>
          <button *ngIf="selectedCampaign.generate_html_id" class="btn btn-primary"
            (click)="editInGenerator(selectedCampaign)">
            Editer dans le générateur
          </button>
          <button *ngIf="selectedCampaign.status === 'ACTIVE'" class="btn btn-warning"
            (click)="pauseCampaign(selectedCampaign)">
            Pause
          </button>
          <button *ngIf="selectedCampaign.status === 'PAUSED'" class="btn btn-success"
            (click)="resumeCampaign(selectedCampaign)">
            Reprendre
          </button>
          <button *ngIf="selectedCampaign.status !== 'STOPPED'" class="btn btn-danger"
            (click)="stopCampaign(selectedCampaign)">
            Arreter
          </button>
          <button class="btn btn-outline-danger" (click)="deleteCampaign(selectedCampaign)">
            Supprimer
          </button>
        </div>
      </div>

      <div class="detail-info">
        <div class="info-row">
          <span class="label">Statut</span>
          <span [ngClass]="getStatusClass(selectedCampaign.status)">{{ selectedCampaign.status }}</span>
        </div>
        <div class="info-row">
          <span class="label">Heure de mise à jour des produits</span>
          <span>{{ selectedCampaign.run_hour }}h UTC</span>
        </div>
        <div class="info-row">
          <span class="label">Total des mises à jour</span>
          <span>{{ selectedCampaign.total_runs }}</span>
        </div>
        <div class="info-row">
          <span class="label">Creee le</span>
          <span>{{ selectedCampaign.created_at | date:'dd/MM/yyyy' }}</span>
        </div>
        <div class="info-row" *ngIf="selectedCampaign.last_used_at">
          <span class="label">Derniere utilisation</span>
          <span>{{ selectedCampaign.last_used_at | date:'dd/MM/yyyy' }}</span>
        </div>
        <div class="info-row">
          <span class="label">Auto-pause apres</span>
          <span>{{ selectedCampaign.max_inactive_days }} jours d'inactivite</span>
        </div>
      </div>

      <!-- Metriques -->
      <div class="metrics-section">
        <h6 style="margin-top: 20px; margin-bottom: 12px;">Reporting (30 derniers jours)</h6>
        <div *ngIf="metricsLoading" class="metrics-loading">Chargement...</div>
        <div *ngIf="!metricsLoading && metrics" class="detail-info">
          <div class="info-row">
            <span class="label">Impressions blocs dynamiques</span>
            <span>{{ metrics.total_impressions | number }}</span>
          </div>
          <div class="info-row">
            <span class="label">Clics blocs dynamiques</span>
            <span>{{ metrics.total_clicks | number }}</span>
          </div>
          <div class="info-row">
            <span class="label">CTR</span>
            <span>{{ metrics.ctr }}%</span>
          </div>
        </div>
        <div *ngIf="!metricsLoading && metrics?.top_products?.length" class="top-products">
          <p class="label" style="font-size: 13px; color: #666; margin-bottom: 8px; font-weight: 500;">Produits les plus
            cliqués :</p>
          <div class="detail-info">
            <div *ngFor="let p of (metrics?.top_products || []); let i = index" class="info-row">
              <span class="label">#{{ i + 1 }} - {{ p.product_id || 'Slot ' + p.slot_index }}</span>
              <span>{{ p.total }} clics</span>
            </div>
          </div>
        </div>
        <div *ngIf="!metricsLoading && metrics && metrics.total_impressions === 0" class="no-data"
          style="font-size: 13px; color: #666; margin-bottom: 20px;">
          Aucune donnee de tracking encore. Les impressions et clics apparaitront apres le prochain envoi.
        </div>
      </div>

      <!-- Recent Runs -->
      <div class="runs-section" *ngIf="selectedCampaign.last_runs?.length">
        <h6>Dernières mises à jour</h6>
        <div class="runs-list">
          <div *ngFor="let run of selectedCampaign.last_runs" class="run-item">
            <span class="run-icon">{{ getRunStatusIcon(run.status) }}</span>
            <span class="run-date">{{ run.run_date | date:'dd/MM' }}</span>
            <span class="run-users">{{ run.users_processed }} contacts</span>
            <span class="run-new" *ngIf="run.new_products_detected > 0">
              +{{ run.new_products_detected }} produits
            </span>
            <span class="run-duration">{{ run.duration_seconds }}s</span>
            <span class="run-error" *ngIf="run.error_message" [title]="run.error_message">
              Erreur
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Dialog Apercu Email -->
<ng-template #previewDialog let-ref="dialogRef">
  <nb-card class="preview-dialog-card">
    <nb-card-header class="preview-dialog-header">
      <span>Apercu — {{ selectedCampaign?.name }}</span>
      <button nbButton ghost size="small" (click)="ref.close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </nb-card-header>
    <nb-card-body class="preview-dialog-body">
      <img *ngIf="previewUrl" [src]="previewUrl" alt="Apercu" class="preview-image" />
    </nb-card-body>
  </nb-card>
</ng-template>